import React, { CSSProperties, ReactElement } from 'react'
import styled from 'styled-components'
import { FieldSize } from '../components/FieldStyles'
import colors from '../lib/colors'
import theme from '../lib/theme'

const Styles = styled.div`
  cursor: pointer;
  user-select: none;
  display: inline-flex;
  align-items: center;
  width: fit-content;
  margin-right: 5px;
  &:hover .checkbox-unchecked {
    border-color: ${colors.darkerGray};
  }
  &.checkbox-disabled {
    opacity: 0.5;
    pointer-events: none;
  }
  &.checkbox-error {
    color: ${colors.red};
    .checkbox-box {
      background-color: ${colors.lightestRed};
      border-color: ${colors.red};
    }
    .checkbox-checked {
      background-color: ${colors.red};
      border-color: ${colors.red};
    }
  }
`
const Box = styled.div`
  border: 1px solid ${colors.darkGray};
  min-width: 15px;
  min-height: 15px;
  border-radius: 4px;
  margin-right: 5px;
  transition: 0.3s;
  position: relative;
  &.checkbox-checked {
    transition: 0s;
    background: ${colors.black};
    border-color: ${colors.black};
    :after {
      position: absolute;
      ${theme.inset0};
      margin: 0px auto;
      content: '';
      width: 4px;
      height: 9px;
      border: solid ${colors.white};
      border-width: 0 3px 3px 0;
      transform: rotate(45deg);
    }
  }
  &.checkbox-large {
    min-width: 18px;
    min-height: 18px;
    &.checkbox-checked {
      :after {
        height: 10px;
      }
    }
  }
`
const Label = styled.span`
  padding-right: 4px;
`

export interface IBooleanFieldProps {
  label?: string
  link?: ReactElement
  onChange: (value: boolean) => void
  value: boolean
  disabled?: boolean
  isError?: boolean
  fieldSize?: FieldSize
  style?: CSSProperties
}

function Checkbox({
  label,
  link,
  onChange,
  value,
  disabled,
  isError,
  fieldSize,
  style,
}: IBooleanFieldProps): ReactElement {
  const wrapperDisabled = disabled ? 'checkbox-disabled' : ''
  const wrapperError = isError ? 'checkbox-error' : ''
  const checkboxChecked = value ? 'checkbox-checked' : 'checkbox-unchecked'
  const sizeClass = fieldSize ? `checkbox-${fieldSize}` : ''

  return (
    <Styles className={`${wrapperDisabled} ${wrapperError}`} style={style}>
      <Box
        className={`checkbox-box ${checkboxChecked} ${sizeClass}`}
        onClick={(): void => onChange(!value)}
      />
      <span>
        <Label onClick={(): void => onChange(!value)}>{label}</Label>
        {link}
      </span>
    </Styles>
  )
}
export default Checkbox
